import { render } from "./ViewAssignedStudents.vue?vue&type=template&id=07d87558&scoped=true"
import script from "./ViewAssignedStudents.vue?vue&type=script&lang=js"
export * from "./ViewAssignedStudents.vue?vue&type=script&lang=js"

import "./ViewAssignedStudents.vue?vue&type=style&index=0&id=07d87558&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d87558"]])

export default __exports__